"use client";
import { ReactNode, memo, useEffect, useState } from "react";
import { Box, IconButton, Stack, SxProps } from "@mui/material";
import { CloseIcon, UploadIcon } from "@/icons";
import { DropzoneOptions, useDropzone } from "react-dropzone";

const AppUploadFileActions = ({
  title = "Tải lên tập tin của bạn",
  description = "Hỗ trợ các định dạng đuôi JPG, PNG, JPEG",
  dropzoneOptions,
  onClearFile,
  file,
  url,
  sx,
  hasClearIcon = true,
  isError = false,
}: AppUploadFileActionsProps) => {
  const { getRootProps, getInputProps, acceptedFiles } =
    useDropzone(dropzoneOptions);

  const [imageUrl, setImageUrl] = useState("");

  const handleClearFile = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    acceptedFiles.splice(0, acceptedFiles.length);
    if (onClearFile instanceof Function) {
      onClearFile();
    }
  };

  useEffect(() => {
    setImageUrl(file ? URL.createObjectURL(file) : "");
  }, [file]);

  return (
    <Box
      // className={clsx(
      //   `flex relative border-[1.5px] border-dashed   rounded-1 bg-[#F0F8FE99]
      // opacity-80 justify-center items-center gap-2 hover:cursor-pointer w-full`,
      //   {
      //     "border-primary": !isError,
      //     "border-error": isError,
      //   }
      // )}
      sx={{
        display: "flex",
        position: "relative",
        border: "1.5px dashed",
        borderRadius: "4px",
        backgroundColor: "#F0F8FE99",
        opacity: "0.8",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        cursor: "pointer",
        width: "100%",
        borderColor: !isError ? "var(--primary)" : "var(--error)",
        ...sx,
      }}
      {...getRootProps()}
    >
      {(file || url) && hasClearIcon && (
        <IconButton
          onClick={handleClearFile}
          className="absolute -top-[11px] -right-[11px] p-1 bg-white border-[1.5px] border-border hover:bg-white"
        >
          <CloseIcon
            sx={{
              fontSize: 12,
            }}
          />
        </IconButton>
      )}
      <Stack
        spacing={1}
        sx={{
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <input {...getInputProps()} />
        {file || url ? (
          <Box
            sx={{
              objectFit: "cover",
              maxWidth: "100%",
              maxHeight: "100%",
              mt: "0px !important",
              borderRadius: "4px",
            }}
            component="img"
            src={imageUrl || url}
          />
        ) : (
          <>
            <UploadIcon
              sx={{
                width: "40px",
                height: "38px",
                cursor: "pointer",
                color: "primary.main",
              }}
            />
            <Box className="h4 font-semibold text-center">{title}</Box>
            <Box className="h7 text-secondary text-center px-5">
              {description}
            </Box>
          </>
        )}
      </Stack>
    </Box>
  );
};

export default memo(AppUploadFileActions);

export type AppUploadFileActionsProps = {
  sx?: SxProps;
  title?: ReactNode;
  description?: ReactNode;
  file?: File;
  url?: string;
  dropzoneOptions: DropzoneOptions;
  onClearFile?: () => void;
  hasClearIcon?: boolean;
  isError?: boolean;
};
